import { Box, Flex, Icon, Text, useColorModeValue } from "@chakra-ui/react";
import React from "react";
import { FaDownload, FaClock } from "react-icons/fa";

function TransactionRow(props) {
  const textColor = useColorModeValue("gray.700", "white");
  const { name, date, price, estatus, adjuntos } = props;

  function formatearFecha(fechaString) {
    const opciones = {
      day: "2-digit",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };

    const fecha = new Date(fechaString);

    if (!(fecha instanceof Date) || isNaN(fecha)) {
      console.error("Valor de fecha inválido:", fecha);
      return "Fecha inválida"; // O maneja el error de otra manera
    }

    //console.log(new Intl.DateTimeFormat('es-ES', opciones).format(fecha))

    return new Intl.DateTimeFormat("es-ES", opciones).format(fecha);
  }

  const obtenerruta = (adjuntos, tipo) => {
    let json = JSON.parse(adjuntos);
    for (let i = 0; i < json.length; i++) {
      if (tipo == "ruta") {
        return json[i].ruta;
      }
    }
  };

  return (
    <Flex my="1rem" justifyContent="space-between">
      <Flex alignItems="center">
        {estatus == "Pagado" ? (
          <a
            href={`${process.env.REACT_APP_API}/${obtenerruta(
              adjuntos,
              "ruta"
            )}`}
            target="_blank"
          >
            <Box
              me="12px"
              borderRadius="20%"
              color="#FFF"
              backgroundColor="#003366"
              border="1px solid"
              display="flex"
              alignItems="center"
              justifyContent="center"
              w="35px"
              h="35px"
            >
              <Icon as={estatus == "Pendiente" ? FaClock : FaDownload} />
            </Box>
          </a>
        ) : (
          <Box
            me="12px"
            borderRadius="20%"
            color="#FFF"
            backgroundColor="#003366"
            border="1px solid"
            display="flex"
            alignItems="center"
            justifyContent="center"
            w="35px"
            h="35px"
          >
            <Icon as={estatus == "Pendiente" ? FaClock : FaDownload} />
          </Box>
        )}

        <Flex direction="column">
          <Text
            fontSize={{ sm: "md", md: "lg", lg: "md" }}
            color={textColor}
            fontWeight="bold"
          >
            {name}
          </Text>
          <Text
            fontSize={{ sm: "xs", md: "sm", lg: "xs" }}
            color="gray.400"
            fontWeight="semibold"
          >
            {formatearFecha(date)}
          </Text>
        </Flex>
      </Flex>
      <Box color={estatus == "Pendiente" ? "red.400" : "green.400"}>
        <Text fontSize={{ sm: "md", md: "lg", lg: "md" }} fontWeight="bold">
          {estatus == "Pendiente" ? "- $" : "$"}
          {price}
        </Text>
      </Box>
    </Flex>
  );
}

export default TransactionRow;
